import React, { ButtonHTMLAttributes } from 'react'

import { StyledButton } from './Button.styles'

export interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode
  buttonRef?: React.Ref<HTMLButtonElement>
  marginBottom?: number
  disabledBackgroundColor?: string
}

export const Button: React.FC<IProps> = ({
  children,
  buttonRef = null,
  marginBottom,
  ...props
}) => (
  <StyledButton ref={buttonRef} {...props} marginBottom={marginBottom}>
    {children}
  </StyledButton>
)
